<section class="section-white">
  <div class="section-container-inside">
    <h2 class="section-heading mar-b-32">
      {{ helpingBusinessData?.title }}
    </h2>
    <div class="helping-businesses-container">
      <a
        class="redirect-link"
        href="{{ helpingBusinessData?.buttons?.[0]?.fields?.redirectLink }}"
      >
        <div class="main-bg-image">
          <img
            src="{{ helpingBusinessData?.image?.[0]?.fields?.file?.url }}"
            class="no-hover wid-full display-b"
          />
        </div>
        <div class="view">
          <figure>
            <img
              src="{{ helpingBusinessData?.image?.[1]?.fields?.file?.url }}"
            />
          </figure>
        </div>
        <div class="helping-businesses-logo-container">
          <figure>
            <img
              src="{{ helpingBusinessData?.image?.[2]?.fields?.file?.url }}"
            />
          </figure>
        </div>
      </a>
    </div>
  </div>
</section>
